/**
 * Único sistema de códigos de idioma: formato locale (es-ES, en-GB, pt-PT, it-IT).
 * La app i18n usa códigos cortos (es, en, pt, it) que se convierten aquí.
 */

const I18N_TO_LOCALE: Record<string, string> = {
  es: 'es-ES',
  ca: 'ca-ES',
  eu: 'eu-ES',
  en: 'en-GB',
  pt: 'pt-PT',
  it: 'it-IT',
  fr: 'fr-FR',
  de: 'de-DE',
};

const LOCALE_TO_I18N: Record<string, string> = {
  'es-ES': 'es',
  'ca-ES': 'ca',
  'eu-ES': 'eu',
  'en-GB': 'en',
  'pt-PT': 'pt',
  'it-IT': 'it',
  'fr-FR': 'fr',
  'de-DE': 'de',
};

export type LangCode = 'es-ES' | 'ca-ES' | 'eu-ES' | 'en-GB' | 'pt-PT' | 'it-IT' | 'fr-FR' | 'de-DE';

/**
 * Convierte código i18n (es, en, pt, it) al código locale (es-ES, en-GB, pt-PT, it-IT)
 */
export function toApiLanguageCode(i18nCode: string): string {
  return normalizeToInternalCode(i18nCode);
}

/**
 * Convierte código locale (es-ES, en-GB) a código i18n (es, en)
 */
export function toI18nLanguageCode(locale: string): string {
  const normalized = locale.trim().toLowerCase();
  return LOCALE_TO_I18N[locale] || normalized.split('-')[0] || 'es';
}

/**
 * Normaliza cualquier código de idioma al formato locale.
 * Acepta: "es", "es-ES", "es-es" → "es-ES"
 */
export function normalizeToInternalCode(langCode: string): string {
  langCode = langCode.trim();
  if (!langCode) return 'es-ES';

  // Ya es locale (contiene '-')
  if (langCode.includes('-')) {
    const [lang, region] = langCode.split('-');
    return `${lang.toLowerCase()}-${region.toUpperCase()}`;
  }

  // Es código i18n corto (2 letras)
  if (langCode.length === 2) {
    return I18N_TO_LOCALE[langCode.toLowerCase()] || 'es-ES';
  }

  return 'es-ES';
}
